require('./mortgageRequestExpensesProvision.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { FormattedText, formatText } = require('core/i18n').i18n;
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ helpers
const { formatCurrency } = require('utilities/currencyHelper');
// @ commons
const { ContentBox } = require('commonsComponents/contentBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
// @ components
const MortgageRequestExpensesAmmount = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestExpensesAmmount/mortgageRequestExpensesAmmount');
const MortgageRequestAmountCostEstates = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestAmountCostEstates/mortgageRequestAmountCostEstates');
const MortgageRequestCurrencyHelp = require('components/mortgageRequest/mortgageRequestCurrencyHelp/mortgageRequestCurrencyHelp');
const MortgageRequestAssociatedAccount = require('components/mortgageRequest/mortgageRequestAssociatedAccount/mortgageRequestAssociatedAccount');
const MortgageRequestAmountMortgagesExpenses = require('components/mortgageRequest/mortgageRequestExpenses/mortgageRequestAmountMortgagesExpenses/mortgageRequestAmountMortgagesExpenses');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ actions
const getExpensesAction = require('actions/mortgageRequest/mortgageRequestExpensesProvision');

// @ constants
const { HOUSING_STATUS } = require('constants/mortgageRequestMortgageDataTypes');
const mortgageRequestStates = require('constants/mortgageRequestStates');

class MortgageRequestExpensesProvision extends React.Component {
    constructor(props) {
        super(props);

        this.handleGoToPanel = this.handleGoToPanel.bind(this);
        this.getTitle = this.getTitle.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { mortgageRequestState, requestExpensesProvision } = this.props;
        const currentIdExpediente = mortgageRequestState.get('idExpediente');

        requestExpensesProvision(currentIdExpediente);
    }

    getBalance(accountNumber) {
        const { immAccounts } = this.props;
        const immAccountsList = immAccounts.get('byOrder');
        const immAccountsById = immAccounts.get('byId');
        let product = '';
        let contractNumber = '';
        let balance = '';

        if (accountNumber) {
            const accountNumberLength = accountNumber.length;
            contractNumber = accountNumber.substring(accountNumberLength - 7);
            product = accountNumber.substring(accountNumberLength - 10, accountNumberLength - 7);

            immAccountsList.forEach((account) => {
                const immAccount = immAccountsById.get(account);

                if (immAccount.get('contractNumber') === contractNumber && immAccount.get('product') === product) {
                    balance = immAccount.getIn(['balance', 'amount']).toString();
                    return false;
                }
            });
        }

        return balance;
    }

    getTitle(quote) {
        return (
            <span>
                {formatText('mortgageRequestExpensesProvision-contentTitle1')} <sup>{quote}</sup>{' '}
                {formatText('mortgageRequestExpensesProvision-contentTitle2')}
            </span>
        );
    }

    handleGoToPanel() {
        this.props.history.push(this.props.linkToPanel);
    }

    isStateInProvFondosOrBefore(state) {
        const provFondosAndStatesBefore = [
            mortgageRequestStates.APORTAR_DOC,
            mortgageRequestStates.AUT_CIRBE,
            mortgageRequestStates.AUT_CIRBE_CO,
            mortgageRequestStates.WAIT_CIRBE_COT,
            mortgageRequestStates.DATOS_VIV,
            mortgageRequestStates.TRAMITAR_NS,
            mortgageRequestStates.WAIT_NS,
            mortgageRequestStates.PROBLEMA_NS,
            mortgageRequestStates.PEND_TASACION,
            mortgageRequestStates.TRAMITAR_TAS,
            mortgageRequestStates.WAIT_DICTAMEN,
            mortgageRequestStates.ANALISIS_TAS,
            mortgageRequestStates.APROBADO_RIESGOS,
            mortgageRequestStates.GENERANDO_OV,
            mortgageRequestStates.PROV_FONDOS,
            mortgageRequestStates.CONFIRMA_DATOS_T2,
            mortgageRequestStates.APERTURA_CUENTA,
            mortgageRequestStates.ESPERA_DOC_FIRMA
        ];

        return provFondosAndStatesBefore.includes(state);
    }

    render() {
        let content;
        const { expensesProvision, linkToPanel, mortgageRequestState, immMortgageData } = this.props;
        const arrasNotAvailable = formatText('mortgageRequestExpensesAmmount-arrasNotAvailable');
        const valorArras = expensesProvision.get('arras')
            ? expensesProvision.get('valorArras')
            : arrasNotAvailable;
        const propertiePurpose = immMortgageData.getIn(['data', 'estadoVivienda']);
        const isNewProperty = propertiePurpose === HOUSING_STATUS.NUEVA ? true : false;
        const currencyFormatted = formatCurrency('EUR');
        const aportacionFondosPropios = expensesProvision.get('aportacionFondosPropios');
        const quote = '(1)';
        const accountNumber = expensesProvision.get('cuenta');
        const balance = this.getBalance(accountNumber);
        const paramsExpensesOwnProvision = {
            currency: aportacionFondosPropios,
            symbolCurrency: 'EUR',
            periodicy: false,
            isFormated: true,
            classes: {
                symbol: "mortgage-request-expenses-provision__expenses-currency"
            },
            withDecimals: true
        }
        const paramsOwnFounds = {
            currency: aportacionFondosPropios,
            symbol: 'EUR',
            periodicy: false,
            isFormated: false,
            classes: false,
            withDecimals: true
        }
        const expensesOwnProvision = MortgageRequestCurrencyHelp(paramsExpensesOwnProvision);
        const ownFounds = MortgageRequestCurrencyHelp(paramsOwnFounds);
        const showInfoMessage = this.isStateInProvFondosOrBefore(mortgageRequestState.get('estado'));
        const infoMessageTitle = formatText('mortgageRequestExpensesProvision-mortgageRequestExpensesProvision_infoMessageTitle');


        if (expensesProvision.get('isFetching')) {
            content = <LoadingSection />;
        } else if (showInfoMessage) {
            content = (
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="expenses-provision-info-message">
                            <ContentBox>
                                <i className="expenses-provision-info-message__icon" />
                                <div className="expenses-provision-info-message__title">
                                    <OKBoxTitle value={infoMessageTitle} />
                                </div>
                                <div className="expenses-provision-info-message__content">
                                    <FormattedText value="mortgageRequestExpensesProvision-mortgageRequestExpensesProvision_infoMessageDescription" />
                                </div>
                                <div className="expenses-provision-info-message__footer">
                                    <div className="expenses-provision-info-message__link">
                                        <OKLink to={linkToPanel} name="returnLink" modifier="inherit-styles" >
                                            <FormattedText value="mortgageRequestExpensesProvision-mortgageRequestExpensesProvision_infoMessageGoBackLink" />
                                        </OKLink>
                                    </div>
                                </div>
                            </ContentBox>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = (
                <ContentBox>
                    <div className="mortgage-request-expenses-provision__title">
                        <OKBoxTitle value={this.getTitle(quote)} size="medium">
                            <sup>{quote}</sup>&nbsp;
                            {formatText('mortgageRequestExpensesProvision-contentSubtitle')}
                        </OKBoxTitle>
                    </div>

                    <div className="mortgage-request-expenses-provision__expenses row no-outside-gutter">
                        <div className="col-xs-9 mortgage-request-expenses-provision__expenses__block">
                            <div className="col-xs-12 mortgage-request-expenses-provision__expenses-box-title">
                                <div className="row">
                                    <FormattedText
                                        value="mortgageRequestExpensesProvision-mortgageRequestExpensesProvision_detailExpensesContributions"
                                        className="mortgage-request-expenses-provision__expenses-box-title--title"
                                    />
                                </div>
                            </div>

                            <MortgageRequestAmountCostEstates
                                importeCompraVenta={expensesProvision.get('importeTotalCompraVenta')}
                                totalmortgagedProperties={expensesProvision.get('importeVivienda')}
                                totalNoMortagagedProperties={expensesProvision.get('importeCompraVentaOtros')}
                            />

                            <MortgageRequestExpensesAmmount
                                importeHipoteca={expensesProvision.get('importeHipoteca')}
                                valorArras={valorArras}
                                currencyFormatted={currencyFormatted}
                                pendingSale={expensesProvision.get('pendingSale')}
                                isNewProperty={isNewProperty}
                                iva={expensesProvision.get('iva')}
                            />

                            <MortgageRequestAmountMortgagesExpenses
                                totalGastos={expensesProvision.get('totalGastos')}
                                expensesProvision={expensesProvision}
                                currencyFormatted={currencyFormatted}
                                isNewProperty={isNewProperty}
                            />

                            <div className="mortgage-request-expenses-provision__amount-item">
                                <div className="mortgage-request-expenses-provision__amount-item__title col-xs-9">
                                    <FormattedText value="mortgageRequestExpensesAmmount-funding" />
                                </div>
                                <div className="mortgage-request-expenses-provision__amount-item__value col-xs-3">
                                    {ownFounds}
                                </div>
                            </div>
                        </div>

                        <div className="mortgage-request-expenses-provision__expenses-information col-xs-3">
                            <div className="mortgage-request-expenses-provision__expenses-description">
                                <FormattedText
                                    value="mortgageRequestExpensesProvision-expensesTitle"
                                    className="mortgage-request-expenses-provision__expenses-title"
                                />
                                <div className="mortgage-request-expenses-provision__expenses-total">
                                    <span className="mortgage-request-expenses-provision__expenses-amount">
                                        {expensesOwnProvision}
                                    </span>
                                </div>
                                <FormattedText
                                    value="mortgageRequestExpensesProvision-expensesSubtitle"
                                    className="mortgage-request-expenses-provision__expenses-subtitle"
                                />
                            </div>

                            <div className="mortgage-request-expenses-provision__expenses-message">
                                <p>
                                    <FormattedText value="mortgageRequestCommons-mortgageExpensesmessage" />
                                </p>

                                <FormattedText
                                    value="mortgageRequestExpensesProvision-contentImportantMessage"
                                    className="mortgage-request-expenses-provision__expenses-message--content"
                                />
                            </div>
                        </div>
                    </div>

                    <MortgageRequestAssociatedAccount accountNumber={accountNumber} balance={balance} />

                    <div className="mortgage-request-expenses-provision__warning">
                        <OKMessage type="informative">
                            <FormattedText value="mortgageRequestExpensesProvision-warningMessage" />
                        </OKMessage>
                    </div>
                    <div className="mortgage-request-expenses-provision__footer row no-outside-gutter">
                        <div className="mortgage-request-expenses-provision__text col-xs-10 mortgage-request-expenses-provision__margin-button">
                            <OKLink modifier="emphasize" name="returnLink" to={linkToPanel}>
                                {formatText('mortgageRequestCommons-returnText')}
                            </OKLink>
                        </div>

                        <div className="col-xs-2 mortgage-request-expenses-provision__right-content">
                            <OKButton
                                block={true}
                                onClick={this.handleGoToPanel}
                                modifier="primary"
                            >
                                {formatText('mortgageRequestCommons-acceptButtonText')}
                            </OKButton>
                        </div>
                    </div>
                </ContentBox>
            );
        }

        return content;
    }
}

MortgageRequestExpensesProvision.propTypes = {
    expensesProvision: PropTypes.object,
    mortgageRequestState: PropTypes.object,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object,
    immMortgageData: PropTypes.object,
    requestExpensesProvision: PropTypes.func,
    setField: PropTypes.func,
    linkToPanel: PropTypes.string
};

MortgageRequestExpensesProvision.defaultProps = {
    linkToPanel: '/myprofile/mortgage/panel#step-3'
};

module.exports.constructor = MortgageRequestExpensesProvision;
module.exports.MortgageRequestExpensesProvision = connect(
    state => ({
        expensesProvision: state.mortgageRequestExpensesProvision,
        mortgageRequestState: state.mortgageRequestState,
        immMortgageData: state.mortgageRequestMortgageData,
        immAccounts: state.accounts
    }), {
        requestExpensesProvision: getExpensesAction.requestExpensesProvision,
        setField: getExpensesAction.setField
    }
)(withRouter(MortgageRequestExpensesProvision));
